import $ from 'jquery'


export const createModal = (title, content, opts={}, footer) => {
  const options = {
    modalCssClass: 'modal fade',
    modalDialogCssClass: 'modal-dialog modal-dialog-centered',
    ...opts,
  }
  const modalEl = $(`
<div class="${options.modalCssClass}" tabindex="-1" role="dialog" aria-labelledby="loginModalTitle" aria-hidden="true">
  <div class="${options.modalDialogCssClass}" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="loginModalTitle">
          ${title}
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" data-redirect-message="{% trans "redirecting..." %}">
          ${content}
      </div>
      <div class="modal-footer">
        ${footer || ''}
      </div>
  </div>
  </div>
</div>
`)
  $(document.body).append(modalEl)
  modalEl.modal()
  return modalEl
}

